import { Fade, Toolbar } from "@material-ui/core";
import Loader from "@qpr/client-api-base/ui/components/Loader";
import PageContainer from "design/layouts/PageContainer";
import React from "react";
type TPlainTab = () => JSX.Element;
type TSelectableTab = (props: { selected?: string }) => JSX.Element;
const Page = (
  props: React.PropsWithChildren<{
    isLoading?: boolean;
    Toolbar: TPlainTab | TSelectableTab;
    className?: string;
  }>
) => {
  return (
    <div style={{ width: "100%" }} className={props.className}>
      <props.Toolbar />
      {props.isLoading ? <Loader /> : null}
      {!props.isLoading ? <div> {props.children}</div> : null}
    </div>
  );
};

export default Page;
